var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-row',[_c('b-col',{attrs:{"cols":"12"}},[_c('BasicForm'),_c('SampleForm'),_c('DisabledForm'),_c('DefaultBasicForm')],1),_c('b-col',{attrs:{"cols":"12","lg":"6"}},[_c('LoginForm')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }